/**
 * Pager text for the vault dashboard panels.
 *
 * Every panel lists a Laravel paginator response (`current_page`, `per_page`,
 * `total`, `from`, `to`, `last_page`). The shared DashboardPanel shows
 * "1 to 5 of 11" instead of the old "Total: 11". No imports, so it runs under
 * `node --test`.
 */

const number = (value, fallback = 0) => {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : fallback;
};

/** True when the list does not fit on one page. */
export function hasPages(paginator) {
    if (!paginator) {
        return false;
    }
    const total = number(paginator.total);
    const perPage = number(paginator.per_page);
    return perPage > 0 && total > perPage;
}

/** "1 to 5 of 11", or "" when there is nothing to page. */
export function pagerLabel(paginator) {
    if (!paginator || number(paginator.total) === 0) {
        return "";
    }
    const total = number(paginator.total);
    const perPage = number(paginator.per_page);
    const page = Math.max(1, number(paginator.current_page, 1));
    const from = paginator.from ?? (perPage ? (page - 1) * perPage + 1 : 1);
    const to = paginator.to ?? (perPage ? Math.min(page * perPage, total) : total);

    return `${from} to ${to} of ${total}`;
}
